





















import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BaseIconButton",
  components: { BaseIcon, BaseSpinner },
  props: {
    fontSize: { type: [String, Number], default: 24 },
    color: { type: String },
    showIndicator: { type: Boolean },
    to: { type: Object as () => Location },
    href: { type: String },
    medium: { type: Boolean },
    textLike: { type: Boolean },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean },
    spinnerColor: { type: String },
  },
});
